import { capitalize } from 'lodash';
import Button from 'components/Button';
import classNames from 'styles/utils/classNames';

interface FinishStepProps {
  visible: boolean;
  playerName: string;
  onFinish: () => void;
}

const FinishStep: React.FC<FinishStepProps> = ({ visible, playerName, onFinish }) => {
  return (
    <div className={classNames('hidden ', visible && '!block')}>
      <div className="flex flex-col items-center justify-center px-8 pt-8 text-center">
        <img src="/images/players/check.png" alt="finish" className="h-auto max-w-[7.5rem]" />
        <h3 className="typography-product-display mt-12 text-color-text-lightmode-primary">
          Finished
        </h3>
        <p className="typography-product-body mt-3 text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          {capitalize(playerName)} will be notified. You can view this recap at any time from the
          Players tab.
        </p>
      </div>
      <div className="mt-[10rem] px-8 pb-8">
        <Button variant="primary" size="lg" onClick={onFinish}>
          Players
        </Button>
      </div>
    </div>
  );
};

export default FinishStep;
